import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Layout from "../../component/Layout";
import api from "../../axios";
import { useNavigate } from "react-router-dom";

const Devices = () => {
  const [devices, setDevices] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showOnlyUnapproved, setShowOnlyUnapproved] = useState(false);
  const [sortOrder, setSortOrder] = useState("asc");
  const navigate = useNavigate();

  useEffect(() => {
    const isAdmin = sessionStorage.getItem('isAdmin') === 'true';
    if (!isAdmin) {
      navigate('/dashboard');
      return;
    }
    fetchDevices();
  }, [navigate]);

  const fetchDevices = async () => {
    try {
      const response = await api.get("/api/device");
      setDevices(response.data);
    } catch (error) {
      console.error(error);
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const filteredDevices = devices
    .filter((device) =>
      device.deviceName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      device.deviceIdentifier.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .filter((device) => (showOnlyUnapproved ? !device.isApproved : true))
    .sort((a, b) => {
      if (sortOrder === "asc") {
        return a.deviceName.localeCompare(b.deviceName);
      } else {
        return b.deviceName.localeCompare(a.deviceName);
      }
    });

  const toggleSortOrder = () => {
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  };

  const approveDevice = async (id) => {
    try {
      await api.patch(`/api/device/${id}/approve`);
      fetchDevices();
    } catch (error) {
      console.error(error);
      alert("Onaylama sırasında hata oluştu.");
    }
  };

  const deleteDevice = async (id) => {
    if (window.confirm("Bu cihazı silmek istediğine emin misin?")) {
      try {
        await api.delete(`/api/device/${id}`);
        fetchDevices();
      } catch (error) {
        console.error(error);
        alert("Silme sırasında hata oluştu.");
      }
    }
  };

  return (
    <>
      <Helmet>
        <title>Cihazlar</title>
        <meta name="description" content="Cihaz yönetimi sayfası" />
      </Helmet>
      <Layout pageTitle="Cihazlar">
        <div className="p-6">
          <div className="flex flex-wrap gap-4 mb-6">
            <input
              type="text"
              className="border p-2 rounded w-64"
              placeholder="Cihaz adı veya kimliği ara..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <button
              className="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded"
              onClick={() => setShowOnlyUnapproved(!showOnlyUnapproved)}
            >
              {showOnlyUnapproved ? "Tüm Cihazlar" : "Sadece Onaysızlar"}
            </button>
            <button
              className="px-4 py-2 bg-gray-500 hover:bg-gray-600 text-white rounded"
              onClick={toggleSortOrder}
            >
              {sortOrder === "asc" ? "A-Z Sırala" : "Z-A Sırala"}
            </button>
          </div>

          <div className="overflow-x-auto bg-white rounded-lg shadow">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">#</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Lisans ID</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Cihaz Adı</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Cihaz Kimliği</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Anakart SN</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Disk SN</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">IP (Global)</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">IP (Lokal)</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">MAC</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">RAM (MB)</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Durum</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">İşlem</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {filteredDevices.map((device, index) => (
                  <tr key={device.id}>
                    <td className="px-6 py-4 text-sm">{index + 1}</td>
                    <td className="px-6 py-4 text-sm">{device.licenseId}</td>
                    <td className="px-6 py-4 text-sm">{device.deviceName}</td>
                    <td className="px-6 py-4 text-sm">{device.deviceIdentifier}</td>
                    <td className="px-6 py-4 text-sm">{device.motherboard_SerialNo}</td>
                    <td className="px-6 py-4 text-sm">{device.disk_SerialNo}</td>
                    <td className="px-6 py-4 text-sm">{device.iP_Global}</td>
                    <td className="px-6 py-4 text-sm">{device.iP_Local}</td>
                    <td className="px-6 py-4 text-sm">{device.mac}</td>
                    <td className="px-6 py-4 text-sm">{device.ram}</td>
                    <td className="px-6 py-4 text-sm">
                      <span className={`px-2 py-1 rounded-full text-xs font-semibold ${device.isApproved ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`}>
                        {device.isApproved ? "Onaylı" : "Onay Bekliyor"}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-sm space-x-2">
                      {!device.isApproved && (
                        <button
                          className="px-3 py-1 bg-green-500 hover:bg-green-600 text-white rounded"
                          onClick={() => approveDevice(device.id)}
                        >
                          Onayla
                        </button>
                      )}
                      <button
                        className="px-3 py-1 bg-red-500 hover:bg-red-600 text-white rounded"
                        onClick={() => deleteDevice(device.id)}
                      >
                        Sil
                      </button>
                    </td>
                  </tr>
                ))}
                {filteredDevices.length === 0 && (
                  <tr>
                    <td colSpan="6" className="text-center px-6 py-4">Cihaz bulunamadı.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default Devices;